// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1BzcP","content":"ManualTimeModal_content__32mZo"};